const FR = {
  associationIncorporated: [
    "association déclarée"
  ],
  partnershipIncorporated: [
    "société civile immobilière (SCI)"
  ],
  partnershipUnincorporated: [
    "société en nom collectif (SNC)",
    "société en commandite simple (SCS)",
    "société en participation (SEP)"
  ]
};
export {
  FR as default
};
